import { Component, Input } from '@angular/core';

@Component({
  selector: 'custom-loader',
  templateUrl: './custom-loader.component.html',
  styleUrls: ['./custom-loader.component.css']
})
export class CustomLoaderComponent {
  @Input()
  public iconSize = '24px'; // in pixels

  @Input()
  public overParent = false;

  @Input()
  public textLoading = '';

  constructor() { }

}
